import { render, staticRenderFns } from "./RtlSupport.vue?vue&type=template&id=e5948aac&"
import script from "./RtlSupport.vue?vue&type=script&lang=js&"
export * from "./RtlSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports